<template>
  <div class="login-container">
    <div class="login">
      <!-- 新增：标题和logo容器 -->
      <div class="title-container">
        <!-- 新增：logo图片 -->
        <img src="https://static-lzufe-lunbot-1258267596.cos.ap-guangzhou.myqcloud.com/static/logo-0.png"
             alt="兰财MBA"
             class="logo-img">
        <h4>兰财校友会MBA分会后台管理系统</h4>
      </div>

      <el-form
          label-width="80px"
          :model="loginData"
      >
        <el-form-item label="账号">
          <el-input placeholder="请输入账号" v-model="loginData.name"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input placeholder="请输入密码" v-model="loginData.password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="subFun" class="sub-btn" type="primary">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {reactive} from 'vue'
import {ElMessage} from 'element-plus'
import {login} from '@/http/api'
import router from '../router/index.js'
// 引入MD5加密库
import md5 from 'js-md5'

export default {
  name: "LoginView",
  setup() {
    let loginData = reactive({
      name: '',
      password: ''
    })

    let subFun = () => {
      // 验证账号密码是否填写
      if (!loginData.name || !loginData.password) {
        ElMessage.error('请先填写账号和密码');
        return
      }

      // 对密码进行MD5加密
      const encryptedPassword = md5(loginData.password)
      console.log(encryptedPassword)
      // 提交加密后的密码到后端
      login({
        loginName: loginData.name,
        password: encryptedPassword
      }).then(res => {
        // 登录成功后跳转
        if (res.code === 200) { // 假设后端返回200为成功
          router.push('/home')
        } else {
          ElMessage.error(res.msg || '登录失败')
        }
      }).catch(err => {
        console.log(err)
        ElMessage.error('网络错误，请重试')
      })
    }

    return {
      loginData,
      subFun
    }
  },
};
</script>

<style scoped>
/* 外层容器设置背景图片 */
.login-container {
  background-image: url('https://static-lzufe-lunbot-1258267596.cos.ap-guangzhou.myqcloud.com/097f9823-c4e5-4346-aaf3-86d7af513c2e.jpg');
  background-size: cover;  /* 背景图片覆盖整个容器 */
  background-position: center;  /* 背景图片居中显示 */
  background-repeat: no-repeat;  /* 背景图片不重复 */
  min-height: 100vh;  /* 确保背景覆盖整个视口高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.login {
  width: 600px;
  background-color: rgba(255, 255, 255, 0.9);  /* 半透明白色背景，增强表单可读性 */
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);  /* 添加阴影效果，增强立体感 */
}

/* 新增：标题和logo容器样式 */
.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

/* 新增：logo图片样式 */
.logo-img {
  width: 100px;
  height: 100px;
  margin-right: 15px;
  object-fit: contain;
}

h4 {
  text-align: center;
  margin: 0;
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
}

.sub-btn {
  width: 100%;
  padding: 10px 0;
  font-size: 1rem;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .login {
    width: 100%;
    max-width: 400px;
  }

  .title-container {
    flex-direction: column;
  }

  .logo-img {
    margin-right: 0;
    margin-bottom: 10px;
  }

  h4 {
    font-size: 1.2rem;
  }
}
</style>
